<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title" :y-domain="yDomain"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Calidad Global Vivienda',
                yDomain: [0,100],
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ8IKIEYKl8crmTGtZgRbNM5ZMJwzGghJM68sYoHI-xW6KCYFnS_Pd6TmGGKXuxGG2xWZZEFXGGOu9N/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTnMKMU_eiAXX2cbwmWVtQmJeqEiRZoHFPhukXEnIFi0bjQQVf_WNojOM7XGP4Yyo2BC0ZH4-jHI2qs/pub?gid=1882655920&single=true&output=csv',
                        dimensions: ['region','zona']
                    },
                    {
                        id: 'genero',
                        title: 'Genero',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQXwCr2RaWNkpTwnNMTY9EdEnATUqIzxmY-2oTZ7uzq9dwrkR6nte_m0yyitE2KClqsyqlWy1aI-ljf/pub?gid=2065192997&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQwN5mqQKYOkCJB0lhVjdz-M36sc1H_fVMDOlNI-21glZMK8Bp1A4F64ApAjtRqXJ3PLWTH_k5z4bOL/pub?gid=1200071717&single=true&output=csv',
                        dimensions: ['region','genero']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRfsa7uOR35cPm1ba1Cys_5WSq8ewFmIsm29E2ARgDH7-xOly4n8HwRgm_c7O6Laq6MJQ_YAOzRHzyB/pub?gid=1927603176&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRvlWO-qgS72L2yoau5LdWtP71dBPE_FXHx5fh3yN1PSfNDPQAXATF_HGrDOum-XVYkFnC_mvB-wGYo/pub?gid=190959505&single=true&output=csv',
                        dimensions: ['region','quintil']
                    }
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRkK6vPJKmJ8BPpfyo2ceG-P05AqgG3QqIIolNUrlXiaQ6ADMmHgbcC0E0ftUA23CsCTJFSHjBQU1_s/pub?gid=521291267&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRNM4rscWk7a3AqRgC8TLkqSk5sIc60Hcv5ow7d3kiWfVTUit5iaG7fFow_XSsLofVwNl3aIUvfKuaG/pub?gid=1335834869&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/QualityHousingVisualization.vue